import * as THREE from "three";
import ForceGraph3D, { ForceGraph3DInstance } from "3d-force-graph";
import cloneDeep from "lodash.clonedeep";

type Node = {
  id: string;
  img: string;
  group: "aws" | "gcp" | "azure" | "onPrem1" | "onPrem2";
  name: string;
  includeInMesh: boolean;
};

type Link = {
  source: string;
  target: string;
  value: number;
};

const runGraph = () => {
  // Wrap in case something breaks that way the rest of the page still renders
  try {
    const targetNode = document.getElementById("netmaker-graph");
    const distance = 600;
    let DEPLOY_URL;
    try {
      // @ts-ignore Injected during build
      DEPLOY_URL = SNIPPET_DEPLOY_URL;
    } catch (error) {
      DEPLOY_URL = "./";
    }
    const awsNodes: Node[] = [
      {
        id: "aws",
        img: "aws.png",
        group: "aws",
        name: "AWS",
        includeInMesh: false,
      },
      {
        id: "aws-jumpServer",
        img: "generic-jump-server.png",
        group: "aws",
        name: "Jump Server",
        includeInMesh: true,
      },
      {
        id: "aws-vpn",
        img: "aws-vpn.png",
        group: "aws",
        name: "VPN Gateway",
        includeInMesh: false,
      },
      {
        id: "aws-load-balancer-1",
        img: "aws-load-balancer.png",
        group: "aws",
        name: "Load Balancer",
        includeInMesh: false,
      },
      {
        id: "aws-load-balancer-2",
        img: "aws-load-balancer.png",
        group: "aws",
        name: "Load Balancer",
        includeInMesh: false,
      },
      {
        id: "aws-load-balancer-3",
        img: "aws-load-balancer.png",
        group: "aws",
        name: "Load Balancer",
        includeInMesh: false,
      },
      {
        id: "aws-ec2-1",
        img: "aws-ec2.png",
        group: "aws",
        name: "Server",
        includeInMesh: true,
      },
      {
        id: "aws-ec2-2",
        img: "aws-ec2.png",
        group: "aws",
        name: "Server",
        includeInMesh: true,
      },
      {
        id: "aws-ec2-3",
        img: "aws-ec2.png",
        group: "aws",
        name: "Server",
        includeInMesh: true,
      },
      {
        id: "aws-ec2-4",
        img: "aws-ec2.png",
        group: "aws",
        name: "Server",
        includeInMesh: true,
      },
      {
        id: "aws-ec2-5",
        img: "aws-ec2.png",
        group: "aws",
        name: "Server",
        includeInMesh: true,
      },
      {
        id: "aws-ec2-6",
        img: "aws-ec2.png",
        group: "aws",
        name: "Server",
        includeInMesh: true,
      },
      {
        id: "aws-vm-1",
        img: "aws-vmware-cloud.png",
        group: "aws",
        name: "VM",
        includeInMesh: true,
      },
      {
        id: "aws-vm-2",
        img: "aws-vmware-cloud.png",
        group: "aws",
        name: "VM",
        includeInMesh: true,
      },
      {
        id: "aws-vm-3",
        img: "aws-vmware-cloud.png",
        group: "aws",
        name: "VM",
        includeInMesh: true,
      },
      {
        id: "aws-rds",
        img: "aws-rds.png",
        group: "aws",
        name: "RDS",
        includeInMesh: true,
      },
      {
        id: "aws-s3-1",
        img: "aws-s3.png",
        group: "aws",
        name: "S3 Artifacts Bucket",
        includeInMesh: true,
      },
      {
        id: "aws-s3-2",
        img: "aws-s3.png",
        group: "aws",
        name: "S3 Static Files Bucket",
        includeInMesh: true,
      },
    ];
    const awsLinks: Link[] = [
      {
        source: "aws-vpn",
        target: "aws",
        value: 1,
      },
      {
        source: "aws-jumpServer",
        target: "aws-load-balancer-1",
        value: 1,
      },
      {
        source: "aws-load-balancer-1",
        target: "aws-vpn",
        value: 1,
      },
      {
        source: "aws-load-balancer-2",
        target: "aws-vpn",
        value: 1,
      },
      {
        source: "aws-load-balancer-3",
        target: "aws-vpn",
        value: 1,
      },
      {
        source: "aws-ec2-1",
        target: "aws-load-balancer-1",
        value: 1,
      },
      {
        source: "aws-ec2-2",
        target: "aws-load-balancer-1",
        value: 1,
      },
      {
        source: "aws-ec2-3",
        target: "aws-load-balancer-1",
        value: 1,
      },
      {
        source: "aws-ec2-4",
        target: "aws-load-balancer-2",
        value: 1,
      },
      {
        source: "aws-ec2-5",
        target: "aws-load-balancer-2",
        value: 1,
      },
      {
        source: "aws-ec2-6",
        target: "aws-load-balancer-2",
        value: 1,
      },
      {
        source: "aws-vm-1",
        target: "aws-load-balancer-3",
        value: 1,
      },
      {
        source: "aws-vm-2",
        target: "aws-load-balancer-3",
        value: 1,
      },
      {
        source: "aws-vm-3",
        target: "aws-load-balancer-3",
        value: 1,
      },
      {
        source: "aws-s3-1",
        target: "aws-vpn",
        value: 1,
      },
      {
        source: "aws-s3-2",
        target: "aws-vpn",
        value: 1,
      },
      {
        source: "aws-rds",
        target: "aws-vpn",
        value: 1,
      },
    ];
    const gcpNodes: Node[] = [
      {
        id: "gcp",
        img: "gcp.png",
        group: "gcp",
        name: "Google Cloud",
        includeInMesh: false,
      },
      {
        id: "gcp-router",
        img: "gcp-router.png",
        group: "gcp",
        name: "Router",
        includeInMesh: false,
      },
      {
        id: "gcp-dns",
        img: "gcp-dns.png",
        group: "gcp",
        name: "DNS",
        includeInMesh: false,
      },
      {
        id: "gcp-firewall",
        img: "gcp-firewall.png",
        group: "gcp",
        name: "Firewall",
        includeInMesh: false,
      },
      {
        id: "gcp-vpn",
        img: "gcp-vpn.png",
        group: "gcp",
        name: "VPN Gateway",
        includeInMesh: false,
      },
      {
        id: "gcp-nat",
        img: "gcp-nat.png",
        group: "gcp",
        name: "NAT",
        includeInMesh: false,
      },
      {
        id: "gcp-iot",
        img: "gcp-iot.png",
        group: "gcp",
        name: "IOT Server",
        includeInMesh: true,
      },
      {
        id: "gcp-ai",
        img: "gcp-ai.png",
        group: "gcp",
        name: "AI Server",
        includeInMesh: true,
      },
      {
        id: "gcp-load-balancer",
        img: "gcp-load-balancer.png",
        group: "gcp",
        name: "Load Balancer",
        includeInMesh: false,
      },
      {
        id: "gcp-compute-1",
        img: "gcp-compute.png",
        group: "gcp",
        name: "Server 1",
        includeInMesh: true,
      },
      {
        id: "gcp-compute-2",
        img: "gcp-compute.png",
        group: "gcp",
        name: "Server 2",
        includeInMesh: true,
      },
      {
        id: "gcp-compute-3",
        img: "gcp-compute.png",
        group: "gcp",
        name: "Server 3",
        includeInMesh: true,
      },
      {
        id: "gcp-mongo",
        img: "gcp-datastore.png",
        group: "gcp",
        name: "MongoDB",
        includeInMesh: true,
      },
    ];

    const gcpLinks: Link[] = [
      {
        source: "gcp-vpn",
        target: "gcp",
        value: 1,
      },
      {
        source: "gcp-router",
        target: "gcp-vpn",
        value: 1,
      },
      {
        source: "gcp-dns",
        target: "gcp-router",
        value: 1,
      },
      {
        source: "gcp-firewall",
        target: "gcp-dns",
        value: 1,
      },
      {
        source: "gcp-nat",
        target: "gcp-firewall",
        value: 1,
      },
      {
        source: "gcp-load-balancer",
        target: "gcp-nat",
        value: 1,
      },
      {
        source: "gcp-compute-1",
        target: "gcp-load-balancer",
        value: 1,
      },
      {
        source: "gcp-compute-2",
        target: "gcp-load-balancer",
        value: 1,
      },
      {
        source: "gcp-compute-3",
        target: "gcp-load-balancer",
        value: 1,
      },
      {
        source: "gcp-ai",
        target: "gcp-nat",
        value: 1,
      },
      {
        source: "gcp-mongo",
        target: "gcp-ai",
        value: 1,
      },
      {
        source: "gcp-iot",
        target: "gcp-nat",
        value: 1,
      },
    ];
    const azureNodes: Node[] = [
      {
        id: "azure",
        img: "azure.png",
        group: "azure",
        name: "Azure",
        includeInMesh: false,
      },
      {
        id: "azure-firewall",
        img: "azure-firewall.svg",
        group: "azure",
        name: "Firewall",
        includeInMesh: false,
      },
      {
        id: "azure-router",
        img: "azure-router.svg",
        group: "azure",
        name: "Router",
        includeInMesh: false,
      },
      {
        id: "azure-virtual-cluster",
        img: "azure-virtual-cluster.svg",
        group: "azure",
        name: "Cluster",
        includeInMesh: false,
      },
      {
        id: "azure-kubernetes-1",
        img: "azure-kubernetes.svg",
        group: "azure",
        name: "Kubernetes Pod 1",
        includeInMesh: true,
      },
      {
        id: "azure-kubernetes-2",
        img: "azure-kubernetes.svg",
        group: "azure",
        name: "Kubernetes Pod 2",
        includeInMesh: true,
      },
      {
        id: "azure-kubernetes-3",
        img: "azure-kubernetes.svg",
        group: "azure",
        name: "Kubernetes Pod 3",
        includeInMesh: true,
      },
      {
        id: "azure-redis",
        img: "azure-redis.svg",
        group: "azure",
        name: "Redis",
        includeInMesh: true,
      },
      {
        id: "azure-sql-server",
        img: "azure-sql-server.svg",
        group: "azure",
        name: "SQL Server",
        includeInMesh: true,
      },
      {
        id: "azure-data-warehouse",
        img: "azure-data-warehouse.svg",
        group: "azure",
        name: "Data Warehouse",
        includeInMesh: true,
      },
    ];
    const azureLinks: Link[] = [
      {
        source: "azure-firewall",
        target: "azure",
        value: 1,
      },
      {
        source: "azure-router",
        target: "azure-firewall",
        value: 1,
      },
      {
        source: "azure-virtual-cluster",
        target: "azure-router",
        value: 1,
      },
      {
        source: "azure-kubernetes-1",
        target: "azure-virtual-cluster",
        value: 1,
      },
      {
        source: "azure-kubernetes-2",
        target: "azure-virtual-cluster",
        value: 1,
      },
      {
        source: "azure-kubernetes-3",
        target: "azure-virtual-cluster",
        value: 1,
      },
      {
        source: "azure-redis",
        target: "azure-kubernetes-1",
        value: 1,
      },
      {
        source: "azure-redis",
        target: "azure-kubernetes-2",
        value: 1,
      },
      {
        source: "azure-redis",
        target: "azure-kubernetes-3",
        value: 1,
      },
      {
        source: "azure-sql-server",
        target: "azure-kubernetes-1",
        value: 1,
      },
      {
        source: "azure-sql-server",
        target: "azure-kubernetes-2",
        value: 1,
      },
      {
        source: "azure-sql-server",
        target: "azure-kubernetes-3",
        value: 1,
      },
      {
        source: "azure-data-warehouse",
        target: "azure-sql-server",
        value: 1,
      },
    ];
    const onPremNodes: Node[] = [
      {
        id: "on-prem",
        img: "generic-on-premise.png",
        group: "onPrem1",
        name: "On-Premise Servers",
        includeInMesh: false,
      },
      {
        id: "on-prem-vpn",
        img: "generic-vpn.png",
        group: "onPrem1",
        name: "Firewall",
        includeInMesh: false,
      },
      {
        id: "on-prem-firewall",
        img: "generic-firewall.png",
        group: "onPrem1",
        name: "Firewall",
        includeInMesh: false,
      },
      {
        id: "on-prem-network",
        img: "generic-network.png",
        group: "onPrem1",
        name: "Local Network",
        includeInMesh: false,
      },
      {
        id: "on-prem-ftp",
        img: "generic-ftp.png",
        group: "onPrem1",
        name: "FTP Server",
        includeInMesh: true,
      },
      {
        id: "on-prem-mail-server",
        img: "generic-mail-server.png",
        group: "onPrem1",
        name: "Mail Server",
        includeInMesh: true,
      },
      {
        id: "on-prem-file-server",
        img: "generic-file-server.png",
        group: "onPrem1",
        name: "File Server",
        includeInMesh: true,
      },
      {
        id: "on-prem-db",
        img: "generic-db.png",
        group: "onPrem1",
        name: "PostgresDB",
        includeInMesh: true,
      },
      {
        id: "on-prem-active-directory",
        img: "generic-active-directory.png",
        group: "onPrem1",
        name: "Active Directory",
        includeInMesh: true,
      },
      {
        id: "on-prem-jenkins",
        img: "jenkins.png",
        group: "onPrem1",
        name: "Jenkins Server",
        includeInMesh: true,
      },
    ];
    const onPremLinks = [
      {
        source: "on-prem-vpn",
        target: "on-prem",
        value: 1,
      },
      {
        source: "on-prem-firewall",
        target: "on-prem-vpn",
        value: 1,
      },
      {
        source: "on-prem-network",
        target: "on-prem-firewall",
        value: 1,
      },
      {
        source: "on-prem-ftp",
        target: "on-prem-network",
        value: 1,
      },
      {
        source: "on-prem-mail-server",
        target: "on-prem-network",
        value: 1,
      },
      {
        source: "on-prem-file-server",
        target: "on-prem-network",
        value: 1,
      },
      {
        source: "on-prem-db",
        target: "on-prem-network",
        value: 1,
      },
      {
        source: "on-prem-jenkins",
        target: "on-prem-network",
        value: 1,
      },
      {
        source: "on-prem-active-directory",
        target: "on-prem-network",
        value: 1,
      },
    ];
    const nodes: Node[] = [
      ...awsNodes,
      ...gcpNodes,
      ...azureNodes,
      ...onPremNodes,
    ];

    const withoutNetmakerLinks: Link[] = [
      ...awsLinks,
      ...gcpLinks,
      ...azureLinks,
      ...onPremLinks,
    ];

    const meshLinks: Link[] = [];

    const nodesToMesh = nodes.filter((n) => n.includeInMesh);
    for (let index = 0; index < nodesToMesh.length; index++) {
      const nodeSource = nodesToMesh[index];

      for (let index = 0; index < nodesToMesh.length; index++) {
        const nodeTarget = nodesToMesh[index];

        // Don't make a link to the node itself
        if (nodeSource.id === nodeTarget.id) {
          continue;
        }

        // Don't make a reverse node for a little performance
        // This does make the nodes one directional
        if (
          meshLinks.find(
            (x) =>
              `${x.source}:${x.target}` === `${nodeTarget.id}:${nodeSource.id}`
          )
        ) {
          continue;
        }

        meshLinks.push({
          source: nodeSource.id,
          target: nodeTarget.id,
          value: 1,
        });
      }
    }

    const withNetmakerMesh = {
      nodes: nodes,
      links: meshLinks,
    };

    const withoutNetmaker = {
      nodes: nodes,
      links: withoutNetmakerLinks,
    };

    let graph: ForceGraph3DInstance | null = null;
    const initGraph = () => {
      graph = ForceGraph3D()(targetNode)
        .nodeThreeObject(({ img }) => {
          // @ts-ignore
          const imgTexture = new THREE.TextureLoader().load(
            `${DEPLOY_URL}/imgs/${img}`
          );
          const material = new THREE.SpriteMaterial({ map: imgTexture });
          const sprite = new THREE.Sprite(material);

          sprite.scale.set(12, 12);
          return sprite;
        })
        .nodeRelSize(10)
        // Decrease size of graphic by 30%
        .height(window.innerHeight * 0.7)
        .showNavInfo(false)
        .graphData(withoutNetmaker)
        .nodeLabel("name")
        .linkWidth(1)
        .linkDirectionalParticles("value")
        .linkDirectionalParticleWidth(1)
        .d3VelocityDecay(0.7)
        .cameraPosition({ z: distance })
        // Faster for Netmaker mesh?
        .linkDirectionalParticleSpeed((d: any) => d.value * 0.005)
        .backgroundColor("#110b35")
        .linkColor((link) => {
          return "#fff";
        });
    };

    initGraph();
    const canvas = document.querySelectorAll("#netmaker-graph canvas")[0];
    canvas.classList.add("netmaker-graph-non-interactive");

    const withoutNetmakerButton = document.getElementById(
      "without-netmaker-button"
    );
    const withNetmakerButton = document.getElementById("with-netmaker-button");
    const toggleExploreButton = document.getElementById("netmaker-explore");

    let cameraInterval: any;
    let angle = 0;

    const rotateGraph = () => {
      cameraInterval = setInterval(() => {
        graph.cameraPosition({
          x: distance * Math.sin(angle),
          z: distance * Math.cos(angle),
        });
        angle += Math.PI / 300;
      }, 50);
    };
    rotateGraph();

    // Set defaults
    withNetmakerButton.classList.add("netmaker-button-inactive");
    if (toggleExploreButton) {
      toggleExploreButton.innerText = "Explore";
    }

    withoutNetmakerButton.addEventListener("click", () => {
      graph.graphData(withoutNetmaker);
      graph.forceEngine("d3");
      graph.numDimensions(3);
      withoutNetmakerButton.classList.remove("netmaker-button-inactive");
      withNetmakerButton.classList.add("netmaker-button-inactive");
    });

    withNetmakerButton.addEventListener("click", () => {
      withNetmakerButton.classList.remove("netmaker-button-inactive");
      withoutNetmakerButton.classList.add("netmaker-button-inactive");
      graph.d3Force("charge").strength(-400);
      // Cloning deep is the only way I could figure out how to reset the visualization
      graph
        .graphData(cloneDeep(withNetmakerMesh))
        .linkDirectionalParticleSpeed((d: any) => d.value * 0.01);
    });

    if (toggleExploreButton) {
      toggleExploreButton.addEventListener("click", () => {
        if (canvas.classList.contains("netmaker-graph-non-interactive")) {
          toggleExploreButton.innerText = "Explore";
          canvas.classList.remove("netmaker-graph-non-interactive");
          clearInterval(cameraInterval);
        } else {
          toggleExploreButton.innerText = "Stop";
          canvas.classList.add("netmaker-graph-non-interactive");
          rotateGraph();
        }
      });
    }
  } catch (error) {
    console.error(error);
  }
};

runGraph();
